import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { useApplicationManager } from '../contexts/ApplicationManagerContext';

/**
 * Hook para login estável que coordena com o ApplicationManager
 * Substitui a lógica complexa de login + reinicialização
 */
export const useStableLogin = () => {
  const navigate = useNavigate();
  const { initialize } = useApplicationManager();

  const login = useCallback(async (email: string, password: string) => {
    try {
      console.log('🔐 Iniciando login estável...');
      
      // 1. Fazer login
      const response = await authService.login(email, password);
      
      if (response.success && response.user) {
        console.log('✅ Login realizado com sucesso');
        
        // 2. Reinicializar ApplicationManager
        console.log('🔄 Reinicializando aplicação...');
        await initialize();
        
        // 3. Navegação será feita automaticamente pelo ApplicationRouter
        console.log('✅ Login estável completo');
        return response;
      } else {
        throw new Error(response.message || 'Erro no login');
      }
    } catch (error) {
      console.error('❌ Erro no login estável:', error);
      throw error;
    }
  }, [initialize]);

  const logout = useCallback(async () => {
    try {
      console.log('🔓 Iniciando logout estável...');
      await authService.logout();
      
      // Navegar para login
      navigate('/login');
      
      console.log('✅ Logout estável completo');
    } catch (error) {
      console.error('❌ Erro no logout estável:', error);
      // Mesmo com erro, redirecionar para login
      navigate('/login');
    }
  }, [navigate]);

  return {
    login,
    logout
  };
};

export default useStableLogin;